import { gql, useMutation } from '@apollo/client';

import { GET_BROKERAGE } from './entities.brokerage.details.query';

const DELETE_BROKERAGE_OFFICE_MUTATION = gql`
  mutation DeleteOfficeFromEntity(
    $entity_uuid: String!
    $office_uuid: String!
  ) {
    deleteOfficeFromEntity(entityUuid: $entity_uuid, officeUuid: $office_uuid) {
      result
      nodesDeleted
      relationshipsDeleted
    }
  }
`;

export function DeleteBrokerageOffice() {
  const [DeleteOfficeFromEntity, { data, loading, error, reset }] = useMutation(
    DELETE_BROKERAGE_OFFICE_MUTATION,
    {
      refetchQueries: [GET_BROKERAGE],
      awaitRefetchQueries: true,
    }
  );

  return {
    data,
    DeleteOfficeFromEntity,
    loading,
    error,
    reset,
  };
}
